import React from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PortableText from '@sanity/block-content-to-react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

import '../css/templates/_blog-post-template.scss';

const serializers = {
  marks: {
    /* eslint-disable */
    link: ({ children, mark }) => (
      <a href={mark.href} target="_blank" rel="noreferrer">
        {children}
      </a>
    ),
    /* eslint-enable */
  },
};

export default function BlogPostTemplate({ data }) {
  const { title, excerpt, slug, _rawBody } = data.sanityPost;

  const morePosts = data.allSanityPost.nodes
    .filter((p) => p.slug.current !== slug.current)
    .slice(0, 2);

  return (
    <Layout>
      <SEO title={title} description={excerpt} />

      <article className="blog-post-template">
        <div className="wrapper">
          <Link to="/blog" className="back-link">
            ← Back to blog
          </Link>

          <header className="post-header">
            <h1>{title}</h1>
          </header>

          <div className="post-body">
            <PortableText blocks={_rawBody} serializers={serializers} />
          </div>
        </div>

        {morePosts.length > 0 && (
          <section className="more-posts">
            <div className="wrapper">
              <h2>More posts</h2>
              <div className="more-grid">
                {morePosts.map((post) => (
                  <Link
                    to={`/blog/${post.slug.current}`}
                    className="post-card"
                    key={post.slug.current}
                  >
                    <div className="thumb">
                      {post.thumbnail && post.thumbnail.asset ? (
                        <GatsbyImage
                          image={post.thumbnail.asset.gatsbyImageData}
                          alt={post.thumbnail.alt || post.title}
                          className="img"
                        />
                      ) : (
                        <div className="thumb-placeholder" />
                      )}
                    </div>
                    <div className="content">
                      <h3>{post.title}</h3>
                      <p>{post.excerpt}</p>
                      <span className="read-more">Read more →</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </article>
    </Layout>
  );
}

export const query = graphql`
  query GetSinglePost($slug: String) {
    sanityPost(slug: { current: { eq: $slug } }) {
      title
      excerpt
      slug {
        current
      }
      _rawBody
    }
    allSanityPost(sort: { fields: publishedAt, order: DESC }) {
      nodes {
        title
        excerpt
        slug {
          current
        }
        thumbnail {
          alt
          asset {
            gatsbyImageData(width: 600, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;
